import { useAuthStore } from '../store/auth-store';

/**
 * Hook de autenticación
 */
export function useAuth() {
  const {
    user,
    token,
    isAuthenticated,
    isLoading,
    error,
    login,
    register,
    logout,
    checkAuth,
    clearError,
    hasPermission,
    canSeeMenu,
    isModuleLocked,
    // La lista cruda hace falta para poder distinguir "no lo tiene" de "todavía
    // no sabemos". Ver el comentario en protected-route.tsx.
    menuItems,
    // Igual que `menuItems`: la lista cruda, para distinguir «no lo tiene» de
    // «todavía no sabemos» (la guarda de /pricing-rules, plan 4B T3).
    permissions,
    organizations,
    activeOrganizationId,
    switchOrganization,
    isImpersonating,
  } = useAuthStore();

  return {
    // Estado
    user,
    token,
    /** Modo soporte: `user` es la persona que se está viendo, no quien la ve. */
    isImpersonating,
    isAuthenticated,
    isLoading,
    error,

    // Organizaciones
    organizations,
    activeOrganizationId,
    switchOrganization,
    activeOrganization: organizations.find((o) => o.id === activeOrganizationId) || null,

    // Acciones
    login,
    register,
    logout,
    checkAuth,
    clearError,

    // Helpers
    hasPermission,
    canSeeMenu,
    isModuleLocked,
    menuItems,
    permissions,
    hasRole: (role: string) => user?.role === role,
    isAdmin: user?.role === 'COMPANY_ADMIN' || user?.role === 'PLATFORM_ADMIN',
    isPlatformAdmin: user?.role === 'PLATFORM_ADMIN',
    fullName: user ? `${user.firstName} ${user.lastName}` : '',
  };
}

export default useAuth;
